"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shopifyOrderApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var shopifyOrderApi = exports.shopifyOrderApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: '/shopifyOrder',
      params: params
    });
  },
  findOne: function findOne(id) {
    return (0, _request.default)({
      url: "/shopifyOrder/".concat(id)
    });
  },
  sync: function sync(data) {
    return (0, _request.default)({
      url: '/shopifyOrder/sync',
      data: data,
      method: 'post'
    });
  }
};